/** Curated world-famous destinations for the homepage slider. */
const WORLD_FAMOUS_DESTINATIONS = [
  {
    name: 'Taj Mahal',
    city: 'Agra',
    state: 'India',
    description: 'An ivory-white marble mausoleum and UNESCO World Heritage Site, symbol of eternal love.',
    image: 'https://images.unsplash.com/photo-1564507592333-c60657eea523?w=1600&q=80',
    searchQuery: 'Agra',
  },
  {
    name: 'Eiffel Tower',
    city: 'Paris',
    state: 'France',
    description: 'The iconic iron lattice tower and one of the most visited monuments in the world.',
    image: 'https://images.unsplash.com/photo-1511739001486-6b10f1a0b4f9?w=1600&q=80',
    searchQuery: 'Paris',
  },
  {
    name: 'Great Wall of China',
    city: 'Beijing',
    state: 'China',
    description: 'A centuries-old fortification stretching thousands of kilometres across northern China.',
    image: 'https://images.unsplash.com/photo-1508804185872-d7badad00f7d?w=1600&q=80',
    searchQuery: 'Beijing',
  },
  {
    name: 'Machu Picchu',
    city: 'Cusco',
    state: 'Peru',
    description: 'A 15th-century Incan citadel set high in the Andes — one of the New Seven Wonders.',
    image: 'https://images.unsplash.com/photo-1587595431973-160d0d94add1?w=1600&q=80',
    searchQuery: 'Cusco',
  },
  {
    name: 'Colosseum',
    city: 'Rome',
    state: 'Italy',
    description: 'Ancient Rome\'s grand amphitheatre, once hosting gladiator contests and public spectacles.',
    image: 'https://images.unsplash.com/photo-1552832230-c0197dd311b5?w=1600&q=80',
    searchQuery: 'Rome',
  },
  {
    name: 'Statue of Liberty',
    city: 'New York',
    state: 'USA',
    description: 'A universal symbol of freedom standing at the entrance to New York Harbor.',
    image: 'https://images.unsplash.com/photo-1485875437342-9b39470b3d95?w=1600&q=80',
    searchQuery: 'New York',
  },
  {
    name: 'Sydney Opera House',
    city: 'Sydney',
    state: 'Australia',
    description: 'A masterpiece of modern architecture and a performing arts venue on Sydney Harbour.',
    image: 'https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?w=1600&q=80',
    searchQuery: 'Sydney',
  },
  {
    name: 'Pyramids of Giza',
    city: 'Cairo',
    state: 'Egypt',
    description: 'The last surviving wonder of the ancient world — monumental tombs of the pharaohs.',
    image: 'https://images.unsplash.com/photo-1539650116574-75c0c6d73a6e?w=1600&q=80',
    searchQuery: 'Cairo',
  },
  {
    name: 'Burj Khalifa',
    city: 'Dubai',
    state: 'UAE',
    description: 'The world\'s tallest building, offering breathtaking views over the Arabian Gulf.',
    image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=1600&q=80',
    searchQuery: 'Dubai',
  },
  {
    name: 'Santorini',
    city: 'Santorini',
    state: 'Greece',
    description: 'Whitewashed villages, blue-domed churches, and legendary sunsets over the Aegean Sea.',
    image: 'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?w=1600&q=80',
    searchQuery: 'Santorini',
  },
];

export default WORLD_FAMOUS_DESTINATIONS;
